import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const Header = ({ activeTab }) => {
  const { t } = useLanguage();
  const titles = {
    journal: t("header.journal"),
    goals: t("header.goals"),
    calendar: t("header.calendar"),
    analytics: t("header.analytics"),
    settings: t("header.settings"),
    admin: t("header.admin"),
  };

  return (
    <header className="flex items-center px-4 py-4 md:px-8 md:py-6">
      <h2 className="text-xl md:text-2xl font-bold text-gray-900 truncate min-w-0">
        {titles[activeTab]}
      </h2>
    </header>
  );
};

export default Header;
